var t = class {
  constructor(s = {}) {
    var e;
    this.apiKey = s.apiKey, this.username = s.username, this.password = s.password, this.accessToken = s.accessToken, this.basePath = s.basePath, this.serverIndex = s.serverIndex, this.baseOptions = {
      ...s.baseOptions,
      headers: { ...(e = s.baseOptions) === null || e === void 0 ? void 0 : e.headers }
    }, this.formDataCtor = s.formDataCtor;
  }
  isJsonMime(s) {
    return s !== null && ((/* @__PURE__ */ new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i")).test(s) || s.toLowerCase() === "application/json-patch+json");
  }
};
export {
  t as Configuration
};

//# sourceMappingURL=configuration.js.map